<template>
    <div class="page">
        <!-- <img src="@/assets/solution/enterprise/solution_banner.png" alt=""> -->
        <p class="expect">敬请期待</p>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.page {
    width: 100%;
    height: 500px;
    background:url("../../assets/solution/enterprise/solution_banner.png") ;

    .expect {
        width: 100%;
        margin: 0;
        padding-top: 50px;
        text-align: center;
        color: #fff;
        font-size: 57px;
    }
}

@media screen and (min-width: 1200px) and (max-width: 1350px) {
    .expect {
        font-size: 37px !important;
    }

}
@media screen and (min-width: 1350px) and (max-width: 1500px){
      .expect {
        font-size: 40px !important;
    }
}
@media screen and (min-width: 1500px) and (max-width: 1700px){
    .expect {
        font-size: 52px !important;
    }
}
</style>